export const BASELINE_TARGET = '*'

// A mark at zero is "nothing read here": what Mark as unread writes. It lies
// before every comment, so all of them count as unread until the place is
// opened again and earns a real mark
export const UNREAD = 0
